import React, { useState } from 'react'
import { Button } from '@iws/admin-ui/button'
import { Input } from '@iws/admin-ui/input'
import { Label } from '@iws/admin-ui/label'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@iws/admin-ui/dialog'

interface NewFolderDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onCreate: (name: string) => void
}

export const NewFolderDialog = ({ open, onOpenChange, onCreate }: NewFolderDialogProps) => {
  const [folderName, setFolderName] = useState('')

  const handleCreate = () => {
    if (!folderName.trim()) return
    onCreate(folderName.trim())
    setFolderName('')
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleCreate()
  }

  return (
    <Dialog open={open} onOpenChange={(v) => { setFolderName(''); onOpenChange(v) }}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>Create folder</DialogTitle>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="folder-name" className="text-sm text-ink">
            Folder name
          </Label>
          <Input
            id="folder-name"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="e.g., Product Images"
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleCreate} disabled={!folderName.trim()}>
            Create folder
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
